// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"03f41c0a","216":"a67ce847"}[chunkId] + ".chunk.css";
};